export default "__VITE_ASSET__yfR0NmkH__"